module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box info-box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h1', {
    staticClass: "text-center"
  }, [_vm._v("THANK YOU!")]), _vm._v(" "), _c('div', {
    staticClass: "main-content text-center"
  }, [_c('i', {
    staticClass: "fa fa-check fa-success fa-lg"
  }), _vm._v(" "), _c('p', {
    staticClass: "main-content__body",
    attrs: {
      "data-lead-id": "main-content-body"
    }
  }, [_vm._v("Payment successful.")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7aebb4b4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/microfinance/Utilities/Phonepe.vue
// module id = 913
// module chunks = 0